import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import ScrollReveal from '../components/ScrollReveal';
import './ProductPage.css';

const RegaPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <ScrollToTop />

      <div className="product-page">
        <section className="product-hero">
          <div className="container">
            <div className="hero-grid">
              <ScrollReveal animation="fade-right">
                <div className="hero-text">
                  <h1>Rega Inteligente</h1>
                  <p className="hero-description">
                    Sistema automatizado de irrigação que otimiza o consumo de água através de sensores IoT
                    e algoritmos inteligentes. Mantenha os seus espaços verdes saudáveis economizando até 30% de água.
                  </p>
                  <div className="hero-buttons">
                    <a href="/#contact" className="cta-btn primary">
                      Pedir Demonstração
                    </a>
                    <a href="tel:+351969059898" className="cta-btn secondary">
                      Contactar Agora
                    </a>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-left" delay={0.2}>
                <div className="hero-image">
                  <img src="/sensor.png" alt="Sistema de Rega Inteligente" loading="lazy" />
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-features">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h2>Funcionalidades Principais</h2>
            </ScrollReveal>

            <div className="features-grid">
              <ScrollReveal animation="fade-up" delay={0.1}>
                <div className="feature-card">
                  <div className="feature-icon">💧</div>
                  <h3>Sensores de Humidade</h3>
                  <p>Monitorização em tempo real da humidade do solo para irrigação precisa.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.2}>
                <div className="feature-card">
                  <div className="feature-icon">🌦️</div>
                  <h3>Previsão Meteorológica</h3>
                  <p>Integração com dados meteorológicos para ajustar automaticamente a rega.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.3}>
                <div className="feature-card">
                  <div className="feature-icon">⚡</div>
                  <h3>Automação Total</h3>
                  <p>Sistema completamente automatizado que funciona 24/7 sem intervenção.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.4}>
                <div className="feature-card">
                  <div className="feature-icon">📲</div>
                  <h3>Controlo Remoto</h3>
                  <p>Gerir e monitorizar o sistema de qualquer lugar através da app móvel.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.5}>
                <div className="feature-card">
                  <div className="feature-icon">🔔</div>
                  <h3>Alertas Inteligentes</h3>
                  <p>Notificações sobre anomalias, manutenção necessária ou problemas no sistema.</p>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-up" delay={0.6}>
                <div className="feature-card">
                  <div className="feature-icon">📈</div>
                  <h3>Análise de Consumo</h3>
                  <p>Relatórios detalhados sobre consumo de água e eficiência do sistema.</p>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-benefits">
          <div className="container">
            <ScrollReveal animation="fade-up">
              <h2>Benefícios para o Seu Negócio</h2>
            </ScrollReveal>

            <div className="benefits-list">
              <ScrollReveal animation="fade-right" delay={0.1}>
                <div className="benefit-item">
                  <div className="benefit-number">01</div>
                  <div className="benefit-content">
                    <h3>Economia de Água até 30%</h3>
                    <p>Reduza drasticamente o desperdício de água com irrigação precisa e inteligente.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.2}>
                <div className="benefit-item">
                  <div className="benefit-number">02</div>
                  <div className="benefit-content">
                    <h3>Redução de Custos Operacionais</h3>
                    <p>Menos água, energia e mão-de-obra = mais lucro para o seu negócio.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.3}>
                <div className="benefit-item">
                  <div className="benefit-number">03</div>
                  <div className="benefit-content">
                    <h3>Plantas Mais Saudáveis</h3>
                    <p>Irrigação optimizada resulta em culturas mais vigorosas e produtivas.</p>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal animation="fade-right" delay={0.4}>
                <div className="benefit-item">
                  <div className="benefit-number">04</div>
                  <div className="benefit-content">
                    <h3>Sustentabilidade Ambiental</h3>
                    <p>Contribua para a preservação de recursos hídricos e sustentabilidade.</p>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>

        <section className="product-cta-section">
          <div className="container">
            <ScrollReveal animation="zoom-in">
              <div className="cta-card">
                <h2>Transforme a Sua Irrigação com Tecnologia</h2>
                <p>
                  Descubra como o sistema de Rega Inteligente da Vulpes pode revolucionar
                  a gestão de água na sua exploração agrícola.
                </p>
                <div className="cta-buttons">
                  <a href="/#contact" className="cta-btn primary large">
                    Solicitar Orçamento Gratuito
                  </a>
                  <Link to="/" className="cta-btn secondary large">
                    Voltar ao Início
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default RegaPage;
